import { useState } from "react";
import { home } from "@/content";
import { Rich } from "@/lib/rich";

export default function LightFAQ() {
  const { faq: section } = home;
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section
      id="faq"
      itemScope
      itemType="https://schema.org/FAQPage"
      className="py-24 bg-white dark:bg-[#0E0E0E] relative overflow-hidden"
    >
      <div className="max-w-3xl mx-auto px-6 relative z-10">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-stone-100 dark:bg-white/[0.06] text-stone-600 dark:text-white/70 text-xs font-semibold tracking-widest uppercase mb-4">
            {section.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 dark:text-white mb-4">
            <Rich text={section.title} accentClassName="text-orange-700 dark:text-orange-400" />
          </h2>
          {section.subtitle && (
            <p className="text-stone-600 dark:text-white/65 text-lg">{section.subtitle}</p>
          )}
        </div>

        <div className="space-y-3">
          {section.items.map((item, index) => (
            <div
              key={item.q}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              className={`rounded-2xl border transition-all duration-200 overflow-hidden ${
                open === index
                  ? "border-stone-300 dark:border-orange-500/20 bg-stone-50 dark:bg-white/[0.04] shadow-[0_2px_8px_rgba(0,0,0,0.02)]"
                  : "border-stone-200 dark:border-white/[0.06] bg-white dark:bg-white/[0.02]"
              }`}
            >
              <button
                type="button"
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                onClick={() => setOpen(open === index ? null : index)}
                aria-expanded={open === index}
              >
                <span
                  itemProp="name"
                  className={`font-semibold text-sm md:text-base pr-4 ${
                    open === index ? "text-stone-900 dark:text-white" : "text-stone-700 dark:text-white/60"
                  }`}
                >
                  {item.q}
                </span>
                <div
                  className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                    open === index ? "bg-stone-900 dark:bg-orange-500 rotate-45" : "bg-stone-100 dark:bg-white/[0.06]"
                  }`}
                >
                  <i
                    className={`ri-add-line text-sm ${
                      open === index ? "text-white dark:text-[#0A0A0A]" : "text-stone-600 dark:text-white/55"
                    }`}
                  ></i>
                </div>
              </button>
              {open === index && (
                <div
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <div itemProp="text" className="px-6 pb-5">
                    <p className="text-stone-600 dark:text-white/65 text-sm leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
